import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@gasbuddy/react-components';
import InputMask from 'react-input-mask';
import classnames from 'classnames/bind';
import styles from './AppSMSInput.module.css';
import { localyticsEvent } from '../../../lib/utils';

const cx = classnames.bind(styles);

export default function AppSMSInput({ actionContent, branchKey, linkData, placeholder }) {
  const [number, setNumber] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [buttonStatusText, setButtonStatusText] = useState(null);

  const mask = '(999) 999 9999';

  const handleInputChange = useCallback((e) => {
    setNumber(e.target.value);
  }, []);

  const handleInputOnFocus = useCallback(() => {
    if (isSubmitted) {
      setNumber('');
      setIsSubmitted(false);
      setButtonStatusText(null);
    }
  }, [isSubmitted]);

  const handleSubmit = useCallback((e) => {
    e.preventDefault();

    localyticsEvent('TextMeTheApp Clicked');

    setIsSubmitting(true);
    // eslint-disable-next-line global-require
    const branch = require('branch-sdk');

    if (branch !== undefined) {
      branch.init(branchKey);
      // eslint-disable-next-line no-unused-vars
      branch.sendSMS(number, linkData, { /* options */ }, (err, result) => {
        let buttonResponse = 'Sent!';
        if (err) {
          buttonResponse = 'Error sending text';
          if (err.message.endsWith('429')) {
            buttonResponse = 'Limit reached';
          }
        }
        setIsSubmitting(false);
        setIsSubmitted(true);
        setButtonStatusText(buttonResponse);
      });
    }
  }, [branchKey, linkData, number]);

  return (
    <div className={cx('container')}>
      <InputMask
        mask={mask}
        type="tel"
        value={number}
        placeholder={placeholder}
        onFocus={handleInputOnFocus}
        onChange={handleInputChange}
        className={cx('telInput')}
      />
      <Button
        primary
        fluid
        type="submit"
        loading={isSubmitting}
        disabled={isSubmitting}
        onClick={handleSubmit}
        className={cx('textLinkButton')}
      >
        {buttonStatusText || actionContent}
      </Button>
    </div>
  );
}

AppSMSInput.propTypes = {
  actionContent: PropTypes.string,
  placeholder: PropTypes.string,
  branchKey: PropTypes.string.isRequired,
  linkData: PropTypes.shape({
    channel: PropTypes.string,
    feature: PropTypes.string,
    data: PropTypes.shape({}),
  }),
};

AppSMSInput.defaultProps = {
  actionContent: 'Text me the link',
  placeholder: 'Enter phone number',
  linkData: {
    channel: 'Website',
    feature: 'TextMeTheApp',
    tags: [],
    data: {},
  },
};
